var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.Login.userLoggedIn)?_c('AppHeader'):_vm._e(),_c('div',{staticClass:"content-wrap"},[(_vm.$store.state.Login.userLoggedIn)?_c('RouterView'):_c('Login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }